<template>
  <div>
    <PostarequirePopup
      :isActive="isDetailsActive"
      :selectedpostrequirement="selectedpostrequirement"
      @close="handleClick"
    />
    <div class="" id="serviceRequirementForm">
      <div class="lg:flex md:flex items-center lg:py-28 md-py-16 py-8">
        <div class="lg:w-1/2 md:w-1/2 w-full lg:px-20 md:px-20 px-5">
          <div class="lg:mt-16 md:mt-16 mt-8">
            <p class="title sm-fsize16 md:font-normal lg:font-normal font-bold">
              Post a Requirement
            </p>
            <!-- <p class="subtitle lg:pt-10 md:pt-10 pt-2 lh32px sm-lh26 sm-fsize13">
            Caregiver Saathi is an ecosystem that enables compassionate caring,
            while also addressing the needs of the caregiver and their overall
            well-being.
            <span class=""
              >A one-stop platform, where family and professional caregivers
              access learning tools, safe support groups, a community of
              experienced caregivers and a range of curated services for
              home-based care.</span
            >
          </p> -->
            <!-- <p class="subtitle lg:pt-8 md:pt-8 lg:pt- 4 md:pt-4 pt-2 lh32px sm-fsize13 sm-lh26  mob-hidden">
            We offer services that provide family caregivers necessary guidance
            through emotional aid, educational content, access to a community of
            experienced caregivers, support groups & counselling, and
            professional services for home based care that you may need during
            your caregiving journey.
          </p> -->
            <p
              class="subtitle lg:pt-10 md:pt-10 pt-2 lh32px sm-lh26 sm-fsize13"
            >
              You can customize your respite care as per your need. It can be
              arranged for an afternoon or several days or weeks. Care can be
              provided at home, in a healthcare facility, or at an adult day
              center.
            </p>
          </div>
          <div class="lg:pt-10 md:pt-10 pt-4">
            <base-button
              outline
              type="primary"
              class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 fs16700 border-2"
              @click="handleClick(true)"
              >Apply Now</base-button
            >
          </div>
        </div>
        <div class="lg:w-1/2 md:w-1/2 w-full">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/5.jpg"
            alt="aboutus"
            class="m-auto smw-390px imgw-530px"
          />
        </div>
      </div>
      <!-- <div class="w-1/2">
        <h2>Post a Requirement</h2>
        <p>
          You can customize you respite care as per your need. It can be
          arranged of an afternoon or serveral days or weeks.care can be
          provided at home.in a healthcare facility, or at an adult day center.
        </p>
      </div>
      <img src="@/assets/images/line/bgline2.svg" alt="" /> -->
    </div>
  </div>
</template>

<script>
import PostarequirePopup from "../../navbar/components/cg-postarequirePopup.vue";

export default {
  components: {
    PostarequirePopup,
  },
  data() {
    return {
      currentRoute: "",
      selectedpostrequirement: {},
      selectedvolunteer: {},

      isvolunteerDetails: false,
      isDetailsActive: false,
    };
  },
  methods: {
    handleClick(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedpostrequirement = item;
    },
  },
};
</script>

<style>
.top-130px {
  top: 130px;
}
@media (max-width: 640px) {
  .sm-top-40px {
    top: -40px;
  }
  .smw-390px {
    width: 390px !important;
  }
}
.imgw-530px {
  width: 530px;
}
</style>
